import { render } from "./App.vue?vue&type=template&id=63fd85ca"
const script = {}

import "./App.vue?vue&type=style&index=0&id=63fd85ca&lang=css"

import exportComponent from "/Users/mac_2/workspace/jukebox-goass/_neu/goass-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__